<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'freePlayIndex',
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/Index.vue